import {
  Box, Divider, IconButton, Typography,
} from '@mui/material';
import styled from 'styled-components';

import {
  BaseColorKeys, NotifierColorKeys, SubjectColorKeys,
} from '../../theme';
import Button from '../Button';
import Link from '../Link';

interface ColorProps {
  color: BaseColorKeys | SubjectColorKeys | NotifierColorKeys;
}

const Container = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(600px, 95%);
    background-color: ${({ theme }) => theme.palette.backdrop.light};
    box-shadow: 24;
    padding: ${({ theme }) => theme.spacing(3)};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    outline: none;
  }
`;

const CloseIconButton = styled(IconButton)`
  && {
    padding: 0
  }
`;

const TitleContainer = styled.div<ColorProps>`
  color: ${({ theme, color }) => theme.palette[color].dark};
  width: 100%;
`;

const DetailDivider = styled(Divider)`
  && {
    margin-top: ${({ theme }) => theme.spacing(2)};
    margin-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;

const EmptyMessageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const UsersList = styled.div`
  max-height: calc(100vh - 320px);
  margin-top: ${({ theme }) => theme.spacing(2)};
  overflow-y: auto;
`;

const UserRow = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  align-items: center;
  &:hover {
    background-color: ${({ theme }) => theme.palette.backdrop.main};
    cursor: pointer;
  }
`;

const UserDescription = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const UserIdentifierStack = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${({ theme }) => theme.spacing(2)};
`;

const UserName = styled(Typography)`
  && {
    width: 100%;
    font-weight: 600;
  }
`;

const UserPhoneNumber = styled(Typography)`
  && {
    width: 100%;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.gray.main};
  }
`;

const ActionContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

const SearchContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const SearchFieldContainer = styled.div`
  width: 100%;
`;

const ActionButton = styled(Button)`
  && {
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;

const ShareButton = styled(Button)`
  && {
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;

const UnshareButton = styled(Button)`
`;

export { Container,
  CloseIconButton,
  UserDescription,
  SearchFieldContainer,
  UserName,
  UserPhoneNumber,
  UsersList,
  ShareButton,
  UnshareButton,
  ActionButton,
  UserRow,
  ActionContainer,
  SearchContainer,
  UserIdentifierStack,
  EmptyMessageContainer,
  DetailDivider,
  TitleContainer };
